import { Component, OnInit } from '@angular/core';
import { StateService } from 'src/app/core/state-manager/appstateservice';
import { PortalConfig, ResourcesType } from 'src/app/portal-config/shared/portal-config.model';
import { PortalConfigService } from 'src/app/portal-config/shared/portal-config.service';

@Component({
  selector: 'app-grants-home',
  templateUrl: './grants-home.component.html',
  styleUrls: ['./grants-home.component.scss']
})
export class GrantsHomeComponent implements OnInit {

  bannerConfig: PortalConfig;
  resourcesType = ResourcesType;
  title = '';
  bgImage = '/assets/images/GrantsHomepage.png';
  portalbannerConfig:boolean=false;

  constructor(private portalService: PortalConfigService, 
              private currentState: StateService) { 
    const bodyElement = document.body;
    bodyElement.style.paddingBottom='0px';
  }

  ngOnInit() {
  }

  ischeckPermissions(permission: string): boolean {  return this.currentState.permissionCheck(permission); }

  getConfig() {
    this.portalService.getConfig(this.resourcesType.Banner).subscribe(data => {
      this.bannerConfig = new PortalConfig().uiMapper(data);
      if (this.bannerConfig.resourcePath !== null && this.bannerConfig.resourcePath !== undefined) {
        this.title = this.bannerConfig.title;
        this.bgImage =  decodeURIComponent(decodeURIComponent(this.bannerConfig.resourcePath));
        this.portalbannerConfig=true;
      }
    });
  }
}
